// src/utils/docRegexUtils.js

/**
 * Central regex patterns for validation & parsing.
 * These are pragmatic, not strict, to support typical user input formats.
 */

// Email: allows common formats like user+tag@example.co.uk
export const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

// Phone: allows optional +country, spaces, dashes, dots, parentheses
// Examples: +1 424-555-1212, (424) 555-1212, 424.555.1212, 4245551212
export const PHONE_RX = /^\s*(?:\+?\d{1,3}[\s.-]?)?(?:\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}\s*$/;

// ZIP: US ZIP 5 or ZIP+4
export const ZIP_RX = /^\d{5}(?:-\d{4})?$/;

// City, State, ZIP (captures groups: city, state, zip)
export const CITY_STATE_ZIP_RX =
  /^\s*([^,]+?)\s*,\s*([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)\s*$/;

// Street line: starts with number or unit, contains common street suffix
export const STREET_RX =
  /^\s*(?:\d+[\w\-]*\s+)?(?:[A-Za-z0-9.#\- ]+)\s+(?:Ave|Avenue|Blvd|Boulevard|Ct|Court|Dr|Drive|Hwy|Highway|Ln|Lane|Pkwy|Parkway|Pl|Place|Rd|Road|St|Street|Way)\b\.?\s*$/i;

// Name: letters with spaces, hyphens, apostrophes
export const NAME_RX = /^[A-Za-z ,.'-]{2,}$/;

// Amount: currency with optional commas/decimals
// Examples: 1,234.56  |  $500  |  500.00
export const AMOUNT_RX = /^\$?\d{1,3}(?:,\d{3})*(?:\.\d{2})?$/;

// Date: YYYY-MM-DD (ISO) or MM/DD/YYYY
export const DATE_RX = /^(?:\d{4}-\d{2}-\d{2}|\d{1,2}\/\d{1,2}\/\d{4})$/;

// URL: http(s)://...
export const URL_RX = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;

/**
 * Quick helper wrappers
 */
export function isEmail(v = "") {
  return EMAIL_RX.test(String(v).trim());
}

export function isPhone(v = "") {
  return PHONE_RX.test(String(v).trim());
}

export function isZip(v = "") {
  return ZIP_RX.test(String(v).trim());
}

export function isCityStateZip(v = "") {
  return CITY_STATE_ZIP_RX.test(String(v).trim());
}

export function isStreet(v = "") {
  return STREET_RX.test(String(v).trim());
}

export function isName(v = "") {
  return NAME_RX.test(String(v).trim());
}

export function isAmount(v = "") {
  return AMOUNT_RX.test(String(v).trim());
}

export function isDate(v = "") {
  return DATE_RX.test(String(v).trim());
}

export function isUrl(v = "") {
  return URL_RX.test(String(v).trim());
}
